import { SuccessIcon } from "components/SvgIcons";
import React from "react";
import { container, text } from "./ProductAddedBanner.css";

export const ProductAddedBanner: React.FC = () => {
  return (
    <div data-testid="product-added-banner" className={container}>
      <SuccessIcon data-testid="SuccessIcon" />{" "}
      <span className={text}>Product Added</span>
    </div>
  );
};
